import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import { ModelSetCharacteristicTable } from '../modelset-characteristic-table';
import { ModelSetCharacteristics } from 'features/premium-report/api/types';
import {
  PORTFOLIO1,
  PORTFOLIO2,
} from 'pages/Cases/hooks/usePostCalculatePortfolioCharacteristics';
import { Slide } from '../../../_data';
import { getSlideField } from '../../../utils';
import { SlideSubtitle } from '../slide-subtitle/slide-subtitle';
import { SlideParagraph } from '../slide-paragraph';

export type PortfolioCharacteristicsProps = [
  {
    field: 'modelSetCharacteristics';
    label: string;
    value: ModelSetCharacteristics[];
    type: 'modelSetCharacteristics';
  },
  {
    field: 'type';
    label: string;
    value: string;
    type: 'string';
  },
];

export const PortfolioCharacteristics = React.memo(
  ({
    slide,
  }: {
    slide: Slide<PortfolioCharacteristicsProps>;
  }): React.ReactElement => {
    const portfolioCharacteristics = getSlideField(
      slide,
      'modelSetCharacteristics',
    )?.value;
    const type = getSlideField(slide, 'type')?.value;

    const portfolioDate = portfolioCharacteristics?.[0]?.portfolio_date;
    return (
      <Grid container direction="column" className={styles.container}>
        {type === '1' && (
          <>
            <Grid item>
              <SlideSubtitle>Portfolio Characteristics</SlideSubtitle>
              <SlideParagraph>
                Based on portfolio allocations as of {portfolioDate}. Exposures,
                fees, and yield may change over time, dependent on investment
                decisions made by strategists and investment managers. Platform
                fees and expense ratios are stated in basis points and as of{' '}
                {portfolioDate}. Equity exposure, yield, high yield, and
                emerging markets bond (EM) exposures are as of {portfolioDate}.
              </SlideParagraph>
              <SlideParagraph>
                *Based on stated maximum fees, may be lower based on any advisor
                exceptions.
              </SlideParagraph>
            </Grid>
          </>
        )}
        <Grid item>
          <ModelSetCharacteristicTable
            data={portfolioCharacteristics}
            template={type === '1' ? PORTFOLIO1 : PORTFOLIO2}
            fontSize={11}
          />
        </Grid>
        <Grid item>
          <SlideParagraph
            style={{
              marginBottom: '10px',
              marginTop: '10px',
              fontSize: '13px',
            }}
          >
            Source: TIFIN Sage
          </SlideParagraph>
        </Grid>
      </Grid>
    );
  },
);
